/**
 * IMPORTANT
 *
 * This file is used only for constants
 * Dont use the logic or methods in te file
 * Avoid using the vue syntax and store comcept.
 */

export const LANDING_PAGE_VIEW = 'landing';
export const VDP_DETAILS_PAGE = 'vdp page';
export const INVENTORY_LISTING_PAGE_VIEW = 'Inventory listing page';
export const MY_GARAGE_PAGE_VIEW = 'my garage page view';
